/**
 * API client for contact form
 */
import { API } from '../../../constants';

const getApiBaseUrl = () => '';
const API_PATH = `${API.VERSION}/contact`;

export const contactApi = {
  /**
   * Send a contact form submission
   */
  async send({ name, email, subject, message }) {
    const url = `${getApiBaseUrl()}${API_PATH}/send`;
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, subject, message })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.detail || 'Failed to send message');
    }
    
    return data;
  },

  /**
   * Test SMTP configuration (admin only)
   */
  async testConnection() {
    const url = `${getApiBaseUrl()}${API_PATH}/test`;
    const response = await fetch(url);
    return response.json();
  }
};

